module.exports = __webpack_public_path__ + "website/img/successfulDetail_4_12.1b6a94e4.jpg";